import { render, staticRenderFns } from "./aptitudeShow.vue?vue&type=template&id=046d01d3&scoped=true"
import script from "./aptitudeShow.vue?vue&type=script&lang=js"
export * from "./aptitudeShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046d01d3",
  null
  
)

export default component.exports